import React, { useContext, useEffect } from 'react';
import { useImmer } from 'use-immer';
import { Card, Button, Form } from 'react-bootstrap'
import { CodingEventTable } from '../../../controls/';
import ConditionalRender from '../../../controls/formControls/ConditionalRender';
import { AuthContext } from '../../../contexts/AuthContext';
import { CodingEventQueueContext } from '../../../contexts/CodingEventQueueContext';

const TeamQueue = (props) => {
    const [canViewAllEvents, setCanViewAllEvents] = useImmer(false);
    const filterType = 'teamQueue';

    const authContext = useContext(AuthContext);
    const context = useContext(CodingEventQueueContext);

    useEffect(() => {
        let canEdit = authContext.hasPermission(authContext.claims.canViewAllEventsFromTeamQueue, authContext.claimValues.isTrue);
        setCanViewAllEvents(canEdit);
    }, [])

    useEffect(() => {
        context.setFilterType(filterType);
    }, []);

    const handleShowAllQueue = () => {
        const value = !context.filters?.showTeamQueue;
        context.setFilterValue("showTeamQueue", value);
    }

    return (
        <Card>
            <Card.Header className="d-flex align-items-center">
                <div className="" >{context.editMode ? "Editing Selected Events" : "Coding Events"}</div>
                <div className="card-btn-group ml-2 mr-auto">

                </div>
                <div className="card-btn-group">
                    <ConditionalRender visible={context.filtered}>
                        <Button variant="secondary" size="sm" onClick={() => context.resetFilters()}>Clear Filters</Button>
                    </ConditionalRender>
                    <ConditionalRender visible={context.editMode} >
                        <Button variant="secondary" size="sm" onClick={() => context.setEditMode(false)}>Cancel Edit</Button>
                        {/* <Button variant="success" size="sm" onClick={() => this.saveSelected()}>Save Changes</Button>*/}
                    </ConditionalRender>
                    <ConditionalRender visible={context.selectedEvents.length > 0 && context.editMode} >
                        <Button variant="secondary" size="sm" onClick={() => context.clearSelectedEvents()}>Clear Selected</Button>
                        {/*<Button variant="primary" size="sm" onClick={() => this.editSelected(true)}>Edit Selected</Button>*/}
                        <Button variant="primary"
                            size="sm"
                            onClick={() => context.editSelected()}>
                            Edit Selected
                            </Button>
                    </ConditionalRender>
                    <ConditionalRender visible={!context.editMode}>
                        <Button size="sm" onClick={() => context.setEditMode(true)}>Edit</Button>
                    </ConditionalRender>
                    <ConditionalRender visible={canViewAllEvents}>
                        <Form.Check
                            type="switch"
                            id="custom-switch"
                            name="showTeamQueue"
                            checked={!context.filters?.showTeamQueue}
                            label="Show all events"
                            onChange={handleShowAllQueue}
                            className="header-control givemethefinger coding-event-switch" />
                    </ConditionalRender>
                </div>
            </Card.Header>
            <Card.Body className="card-body-table">
                <CodingEventTable
                    pageSize="30"
                    canBulkEdit
                />
            </Card.Body>
        </Card>
    )
}

export default TeamQueue;
